import { cn } from '@/lib/utils'

type WordmarkProps = {
  portal: string
  className?: string
  /** Auth card: dark text on white. Sidebar: cream on navy. */
  variant?: 'light' | 'dark'
}

export function Wordmark({ portal, className, variant = 'dark' }: WordmarkProps) {
  const isLight = variant === 'light'

  return (
    <div className={cn('text-center', className)}>
      <p
        className={cn(
          'font-serif text-[1.75rem] font-medium tracking-[0.06em] uppercase',
          isLight ? 'text-cream' : 'text-navy',
        )}
      >
        Riverpark
      </p>
      <div
        className={cn('mx-auto my-3 h-0.5 w-12', isLight ? 'bg-green-lt' : 'bg-green')}
        aria-hidden
      />
      <p
        className={cn(
          'font-sans text-[10px] font-medium uppercase tracking-[0.12em]',
          isLight ? 'text-cream/40' : 'text-muted-foreground',
        )}
      >
        {portal}
      </p>
    </div>
  )
}
